import { inject, Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { CommonSignal, NoticeSignal } from "@xanadu/signal";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private readonly commonSignal = inject(CommonSignal);
    private readonly noticeSignal = inject(NoticeSignal);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError(error => {
                    this.commonSignal.httpError.set(error);
                    this.noticeSignal.error(error.error?.message ?? error.message ?? 'An error occurred.');
                    return throwError(() => error);
                })
            );
    }
}
